import { __awaiter, __generator } from "tslib";
import { defineComponent, ref, watch, onMounted } from 'vue';
import createHTMLMapMarker from "../../hooks/use-html-map-maker";
export default defineComponent({
    name: 'FindLaneMap',
    props: {
        bikeLaneGeomery: {
            type: Array,
            default: function () { return []; }
        },
        laneCenter: {
            type: Object,
            default: function () { return ({ lat: 25.0325917, lng: 121.5624999 }); }
        },
        starAndEnd: {
            type: Array,
            default: function () { return []; }
        },
        zoom: {
            type: Number,
            default: 0
        }
    },
    setup: function (props) {
        var _this = this;
        var map = ref(null);
        var center = ref({
            lat: 25.0325917,
            lng: 121.5624999
        });
        var polylinePath = ref([]);
        var startAndEnd = ref([]);
        var initMap = function () {
            map.value = new window.google.maps.Map(document.getElementById("map"), {
                center: center.value,
                zoom: props.zoom,
                maxZoom: 20,
                minZoom: 3,
                streetViewControl: false,
                mapTypeControl: false,
                disableDefaultUI: true,
            });
            var lineSymbol = {
                path: window.google.maps.SymbolPath.CIRCLE,
                strokeOpacity: 1,
                fillOpacity: 1,
                scale: 3
            };
            var line = new window.google.maps.Polyline({
                path: polylinePath.value,
                strokeOpacity: 0,
                icons: [{
                        icon: lineSymbol,
                        offset: '0',
                        repeat: '20px'
                    }],
                map: map.value
            });
        };
        var setBikeLaneMakers = function () {
            if (startAndEnd.value) {
                props.starAndEnd.map(function (lane, index) { return __awaiter(_this, void 0, void 0, function () {
                    var lat, lng, latling, markers, markers;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!lane)
                                    return [2 /*return*/];
                                lat = lane.lat, lng = lane.lng;
                                return [4 /*yield*/, new window.google.maps.LatLng({ lat: lat, lng: lng })];
                            case 1:
                                latling = _a.sent();
                                if (!(index === 0)) return [3 /*break*/, 3];
                                return [4 /*yield*/, createHTMLMapMarker({
                                        latlng: latling,
                                        map: map.value,
                                        html: "<div class=\"location\">\n                <img class=\"locaion-img\" src=\"img/return-location.png\">\n                <div class=\"count return\">\u59CB</div>\n                </div"
                                    })];
                            case 2:
                                markers = _a.sent();
                                return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, createHTMLMapMarker({
                                    latlng: latling,
                                    map: map.value,
                                    html: "<div class=\"location\">\n                <img class=\"locaion-img\" src=\"img/return-location.png\">\n                <div class=\"count return\">\u7D42</div>\n                </div"
                                })];
                            case 4:
                                markers = _a.sent();
                                _a.label = 5;
                            case 5: return [2 /*return*/];
                        }
                    });
                }); });
            }
        };
        watch(function () { return props.laneCenter; }, function (v) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        center.value = v;
                        return [4 /*yield*/, initMap()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        watch(function () { return props.bikeLaneGeomery; }, function () {
            setBikeLaneMakers();
        });
        watch(function () { return props.bikeLaneGeomery; }, function (v) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = polylinePath;
                        return [4 /*yield*/, props.bikeLaneGeomery];
                    case 1:
                        _a.value = _b.sent();
                        initMap();
                        setBikeLaneMakers();
                        return [2 /*return*/];
                }
            });
        }); });
        watch(function () { return props.zoom; }, function () {
            initMap();
            setBikeLaneMakers();
        });
        onMounted(function () {
            initMap();
        });
        return {
            setBikeLaneMakers: setBikeLaneMakers,
            initMap: initMap,
        };
    },
});
